import { UploadForm } from "./UploadForm";
import goals from "../utils/goals";

export class UploadPromoForm extends UploadForm {
    maxFiles = 1;
    isPromoForm = true;

    onAddFile(file) {
        super.onAddFile(file);
        if (file.size === 0) {
            return;
        }

        goals.reach("startFileUploadPromo");
        this.dropzoneUpload?.disable();
        if (this.dropzone.clickableElements && this.dropzone.clickableElements[1]) {
            this.dropzone.clickableElements[1].style.display = "none";
        }
    }

    onFileComplete(file) {
        super.onFileComplete(file);
        if (file && file.status !== "added") {
            goals.reach("finishFileUploadPromo");
            this.dropzoneUpload?.enable();
            this.dropzone.clickableElements[1].style.display = "";
        }
    }
}
